"use client";

import { useEffect } from "react";

export default function Error({ error, reset }) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <main className="min-h-screen bg-[#F2F2F2] flex items-center justify-center px-4">
      <div className="w-full max-w-lg">
        {/* Card */}
        <div className="bg-white rounded-2xl shadow-sm overflow-hidden">
          {/* Top accent bar */}
          <div className="h-1.5 w-full bg-gradient-to-r from-[#9573F7] via-[#b89dff] to-[#283245]" />

          <div className="px-10 py-12 text-center">
            {/* Icon */}
            <div className="flex justify-center mb-6">
              <div className="relative">
                <div className="w-20 h-20 rounded-full bg-[#9573F7]/10 flex items-center justify-center">
                  <svg
                    className="w-9 h-9 text-[#9573F7]"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={1.5}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
                    />
                  </svg>
                </div>
                {/* Pulse ring */}
                <span className="absolute inset-0 rounded-full border-2 border-[#9573F7]/30 animate-ping" />
              </div>
            </div>

            {/* Badge */}
            <span className="inline-block text-xs uppercase tracking-[0.2em] font-semibold text-[#9573F7] bg-[#9573F7]/10 px-3 py-1 rounded-full mb-4">
              We'll be right back
            </span>

            {/* Heading */}
            <h1 className="text-2xl font-semibold text-[#283245] mb-2 leading-tight">
              This page isn't available right now
            </h1>
            <h2 className="text-xl font-semibold text-[#283245] mb-2 leading-tight">
              We appreciate your patience.
            </h2>
            {/* Message */}
            <p className="text-gray-500 text-sm leading-relaxed mb-2">
              Please check back in a little while - we'll have everything ready
              for you soon.
            </p>

            {/* //error */}
            {error?.message &&
              process.env.NEXT_PUBLIC_ENV === "development" && (
                <p className="text-xs text-gray-400 bg-gray-50 border border-gray-100 rounded-lg px-4 py-2 mt-4 font-mono text-left truncate">
                  {error.message}
                </p>
              )}
            {/* Divider */}
            <hr className="border-gray-100 my-8" />

            {/* Actions */}
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button
                onClick={reset}
                className="flex items-center justify-center gap-2 bg-[#9573F7] hover:bg-[#7a5bd1] text-white text-sm font-medium px-6 py-2.5 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#9573F7] focus:ring-offset-2"
              >
                {/* Retry icon */}
                <svg
                  className="w-4 h-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
                  />
                </svg>
                Try again
              </button>

              <a
                href="/"
                className="flex items-center justify-center gap-2 bg-white border border-gray-200 hover:border-[#9573F7] text-[#283245] hover:text-[#9573F7] text-sm font-medium px-6 py-2.5 rounded-full transition-colors duration-200"
              >
                {/* Home icon */}
                <svg
                  className="w-4 h-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
                  />
                </svg>
                Go home
              </a>
            </div>
          </div>
        </div>

        {/* Footer note */}
        <p className="text-center text-xs text-gray-400 mt-5">
          If this keeps happening, please contact support.
        </p>
      </div>
    </main>
  );
}
